module.exports = __webpack_public_path__ + "media/images/logos/University-of-Melbourne-0619e61c89316200651e06fc8e5ce3dd.svg";